/**
 * This is relevant to dynamic macro copy in Contentful to group
 * messages by their context.
 */
export const INTL_PREFIX = {
  CHECKOUT: 'checkout',
  PAYMENT: 'payment',
  COMMON: 'common',
  ERROR_CODE: 'errorCode',
  ORDER: 'order',
  SERVICE: 'service',
  NFT: 'nft',
  STRAP_PACK: 'strapPack',
  EVENT: 'event',
  ABOUT: 'about',
  CALIBER: 'caliber',
  ORDER_APP: 'orderApp',
} as const;
